import { render, staticRenderFns } from "./cooperativePriceListComponent.vue?vue&type=template&id=0fc60b07&scoped=true&"
import script from "./cooperativePriceListComponent.vue?vue&type=script&lang=js&"
export * from "./cooperativePriceListComponent.vue?vue&type=script&lang=js&"
import style0 from "./cooperativePriceListComponent.vue?vue&type=style&index=0&id=0fc60b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc60b07",
  null
  
)

export default component.exports